import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import './index.less';

/**
 * 生成失败占位卡
 * 灰色边框圆角框 + 中间感叹号图标 + 下方"生成失败"文字 + 错误信息
 */
const FailedCard = ({ count = 1, aspect = '1/1', errorMsg }) => {
  const safeCount = [1, 2, 4].includes(count) ? count : 1;

  return (
    <div className={`failedCard count-${safeCount}`}>
      {Array.from({ length: safeCount }).map((_, idx) => (
        <div key={idx} className="failedItem" style={{ aspectRatio: aspect }}>
          <ExclamationCircleOutlined className="failedIcon" />
          <div className="failedText">生成失败</div>
          {errorMsg && <div className="failedError">{errorMsg}</div>}
        </div>
      ))}
    </div>
  );
};

export default FailedCard;
